import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, ReactNode, useState } from 'react';
import { AiOutlineCopy } from 'react-icons/ai';
import { BsArrowDownCircle, BsArrowLeft, BsArrowUpCircle } from 'react-icons/bs';
import { GoPackage } from 'react-icons/go';

interface IOrderRowWrapper {
  children: ReactNode;
  index: number;
  pack: packageCreate;
  deleteRow: (_index: number) => void;
  copyByIndex: (_index: number) => void;
  useLocker: boolean;
}

const BranchOrderRowWrapper: FC<IOrderRowWrapper> = ({ index, pack, deleteRow, children, copyByIndex, useLocker }) => {
  //state
  const [open, setOpen] = useState<boolean>(true);

  if (useLocker)
    return (
      <>
        <div className='p-4 mb-4 border border-t-border-color-base rounded-xl bg-t-bg-color'>
          <p className='mb-1 text-lg font-medium'>لاکر هوشمند جابار</p>
          <p className='text-sm max-w-[150ch]'>
            لاکر هوشمند یا همان صندوق پستی هوشمند، در مکان‌های مشخص از جمله مراکز خرید، مراکز تجاری و ... مستقر می‌شود و کارکرد اصلی آن حفاظت و نگهداری از مرسولات پستی و سفارشات
            فروشگاه‌های اینترنتی می‌باشد. از طریق این خدمات هوشمند پستی، دریافت کالا در زمان و محل دلخواه مشتری، امکان پذیر است.
          </p>
          <ul className='mt-2 text-sm list-disc list-inside inherit-color'>
            <li>امنیت بالا</li>
            <li>انعطاف پذیری زمانی</li>
            <li>سهولت در استفاده</li>
            <li>سیستم هوشمند</li>
          </ul>
          <div className='flex justify-end'>
            <a href='https://jaa-baar.com/' target='_blank' className='flex items-center gap-2 font-medium text-t-secondary-color' rel='noreferrer'>
              اطلاعات بیشتر <BsArrowLeft />
            </a>
          </div>
        </div>

        <div className='border rounded-2xl border-t-primary-color bg-t-bg-color'>{children}</div>
      </>
    );

  return (
    <div className='mb-4 overflow-hidden border rounded-2xl border-t-primary-color'>
      <div
        className={`flex items-center flex-col sm:flex-row gap-2 px-4 py-2 text-sm border-t-primary-color bg-t-faded-primary-color  ${
          open && 'border-b'
        } transition-all duration-1000`}>
        <div className='flex flex-col w-full gap-1 sm:gap-3 sm:items-center sm:flex-row'>
          <p>سفارش {index + 1} :</p>
          <div className=''>
            <p className='text-xs'>{pack.senderClient?.fullName || ''}</p>
            <p className='text-xs'>{pack.senderAddress?.address?.cityTitle || ''}</p>
          </div>
          <div className='space-y-1'>
            {pack.package?.map((packaging) => (
              <div key={pack.uuid} className='flex px-2 py-1 border rounded-md w-fit border-t-secondary-text-color'>
                <p className='flex items-center ml-1 text-xs gap-x-1'>
                  <GoPackage />
                  {packaging?.title || ''}
                </p>
                <p className='text-xs'>{packaging?.title ? `* ${packaging.count || 1}` : ''}</p>
              </div>
            ))}
          </div>
          <div className=''>
            <p className='text-xs'>{pack.receiverClient?.fullName || ''}</p>
            <p className='text-xs'>{pack.receiverAddress?.address?.cityTitle || ''}</p>
          </div>
        </div>
        {!useLocker && (
          <div className='flex items-center gap-2 mr-auto'>
            {/* {open && <BsArrowUpCircle className='cursor-pointer' onClick={() => setOpen((prevState) => !prevState)} />} */}
            {open && (
              <div
                className='flex items-center gap-1 px-2 py-1 border rounded-full shadow-inner cursor-pointer border-t-border-color-base bg-t-bg-color inherit-color hover:border-t-primary-color'
                onClick={() => setOpen((prevState) => !prevState)}>
                <BsArrowUpCircle className='cursor-pointer' />
                بستن
              </div>
            )}
            {/* {!open && <BsArrowDownCircle className='cursor-pointer' onClick={() => setOpen((prevState) => !prevState)} />} */}
            {!open && (
              <div
                className='flex items-center gap-1 px-2 py-1 border rounded-full shadow-inner cursor-pointer border-t-border-color-base bg-t-bg-color inherit-color hover:border-t-primary-color'
                onClick={() => setOpen((prevState) => !prevState)}>
                <BsArrowDownCircle className='cursor-pointer' />
                باز
              </div>
            )}

            <div
              className='flex items-center gap-1 px-2 py-1 border rounded-full shadow-inner cursor-pointer border-t-border-color-base bg-t-bg-color inherit-color hover:border-t-primary-color'
              onClick={() => copyByIndex(index)}>
              <AiOutlineCopy />
              کپی
            </div>

            {index !== 0 && (
              <Popconfirm onConfirm={() => deleteRow(index)} title='حذف شود؟'>
                <div className='flex items-center gap-1 px-2 py-1 border rounded-full shadow-inner cursor-pointer border-t-border-color-base bg-t-bg-color inherit-color text-t-error-color hover:border-t-error-color'>
                  <DeleteOutlined />
                  حذف
                </div>
              </Popconfirm>
            )}
          </div>
        )}
      </div>
      <div className={`transition-all bg-t-bg-color overflow-hidden duration-1000 ease-in-out ${open ? 'max-h-[2000px]' : 'max-h-[0px]'}`}>{children}</div>
    </div>
  );
};

export default BranchOrderRowWrapper;
